module.exports = __webpack_public_path__ + "static/media/Arthur Weasley 3.24cce625.jpg";